import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import PropTypes from 'prop-types';

/**
 * 월 선택
 */
const MonthPicker = ({ value, onUpdate, ...props }) => {
  /* state */
  // 날짜
  const [date, setDate] = useState();
  // 시작 날짜
  const [start, setStart] = useState(new Date());
  // 끝 날짜
  const [end, setEnd] = useState(new Date());
  // 최소 날짜
  const [min, setMin] = useState(new Date());
  // 최대 날짜
  const [max, setMax] = useState(new Date());

  /* watch */
  useEffect(() => {
    if (!value) {
      return;
    }

    let date = moment(value);

    // 기간 선택 시
    if (props.startDate && props.endDate) {
      let convertDate;

      if (props.selectsStart && date.isAfter(props.endDate)) {
        // 시작 날짜 선택 시 시작 날짜가 끝 날짜 후인 경우 시작 날짜를 끝 날짜로 설정
        convertDate = moment(props.endDate);
      } else if (props.selectsEnd && date.isBefore(props.startDate)) {
        // 끝 날짜 선택 시 끝 날짜가 시작 날짜 전인 경우 끝 날짜를 시작 날짜로 설정
        convertDate = moment(props.startDate);
      }

      if (convertDate) {
        onChange(convertDate.toDate());

        return;
      }
    }

    setDate(date.toDate());
  }, [value]);
  useEffect(() => {
    if (props.start) {
      setStart(moment(props.start).toDate());
    }
  }, [props.start]);
  useEffect(() => {
    if (props.end) {
      setEnd(moment(props.end).toDate());
    }
  }, [props.end]);
  useEffect(() => {
    if (props.min) {
      setMin(moment(props.min).toDate());
    }
  }, [props.min]);
  useEffect(() => {
    if (props.max) {
      setMax(moment(props.max).toDate());
    }
  }, [props.max]);

  /* event */
  // 월 변경 시
  const onChange = date => {
    setDate(date);
    onUpdate(moment(date).format('YYYYMM'));
  };

  /* view */
  return (
    <DatePicker
      className="form-select form-select-sm"
      dateFormat="yyyy-MM"
      selected={date}
      showMonthYearPicker
      onChange={onChange}
      {...props}
      {...((props.selectsStart || props.selectsEnd) && {
        startDate: start,
        endDate: end
      })}
      {...(props.min && { minDate: min })}
      {...(props.max && { maxDate: max })}
    />
  );
};

MonthPicker.propTypes = {
  // 값
  value: PropTypes.string,

  // 값 변경 시 이벤트
  onUpdate: PropTypes.func
};

export default MonthPicker;
